import { ACHIEVEMENTS_PATH } from '../../constants'
import getInstanceIdsReduxSelector from '../../../../redux/selectors/get-instance-ids'

const getAchievementIdsSelector = getInstanceIdsReduxSelector(ACHIEVEMENTS_PATH.DATA,
  ACHIEVEMENTS_PATH.ALL_DATA
)

export default getAchievementIdsSelector
